import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { HomeVisit } from "@/@types/esus/HomeVisit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensAcsVisitsIndicatorC3Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenAcsVisitsIndicatorC3Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	dumDate: string = "";
	dppDate: string = "";
	gestationalAge?: number;
	inactivePregnancyDate?: string;
	pregnancyStatus: "pregnant" | "puerperal" | "finished" = "pregnant";
	acsHomeVisits?: HomeVisit[];
	threeAcsHomeVisitsStatus: "finished" | "pending" | "lost" = "lost";
	puerperalAcsHomeVisits?: HomeVisit[];
	puerperalAcsHomeVisitStatus: "finished" | "pending" | "lost" = "lost";
}

export async function getDetailedCitizensAcsVisitsIndicatorC3({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAcsVisitsIndicatorC3Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAcsVisitsIndicatorC3Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/detailed-citizens-home-visits`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAcsVisitsIndicatorC3Data>();
}
